import router from "./router";
import { getToken } from "@/utils/auth";

// 免登录白名单（与现行口径一致：公开页 + 404 兜底）
const whiteList = [
  "/",
  "/home",
  "/login",
  "/register",
  "/userAgreement",
  "/privacyPolicy",
  "/SystemUpgrade",
  "/feedback",
  "/knowledge",
  "/knowledge/search",
  "/knowledge/insight",
  "/verify",
];

router.beforeEach((to, from, next) => {
  // 系统升级开关：开启时全站只允许停留在升级提示页
  if (process.env.VUE_APP_System_Upgrade == "true" && to.path !== "/SystemUpgrade") {
    next("/SystemUpgrade");
    return;
  }

  if (getToken()) {
    next();
    return;
  }

  if (whiteList.indexOf(to.path) !== -1 || to.name === "notFound") {
    next();
  } else {
    next("/login");
  }
});
